import React, { useEffect } from 'react';
import { Layout } from 'antd';
import Breadcrumbs from '../../components/Breadcrumbs';
import PageTitle from '../../components/PageTitle';
import PageContent from '../../components/PageContent';
import { Footer } from 'antd/es/layout/layout';
import Copyright from '@app/components/Copyright';
import TopMenuContainer from '@app/components/TopMenu/TopMenuContainer';
import { useDispatch } from 'react-redux';
import { setBreadcrumbRoutes } from '@app/redux/actions/breadcrumbActions';

const MasterLayout = (props: any) => {
  const isIframe = window.self !== window.top;
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.routes) {
      dispatch(setBreadcrumbRoutes(props.routes));
    }
  }, [props.routes, dispatch]);

  return (
    <Layout className={'yjMainLayout'} style={{ height: '100vh' }}>
      <Layout>
        <Layout className={'yjMasterLayoutWrapper'}>
          <TopMenuContainer menuConfig={props.menus} />
          {/* <Breadcrumbs routes={props.routes} /> */}
          {props.children}
        </Layout>
      </Layout>
      <Footer style={{ textAlign: 'right', height: '20px', lineHeight: '20px', fontSize: '10px', padding: '0 30px', backgroundColor: '#24303b', color: '#ffffff' }}>
        <Copyright />
      </Footer>
    </Layout>
  );
};

export { PageTitle, PageContent };
export default MasterLayout;
